'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { RouterFilterTags, StyledTagsContainer, ClearFiltersLink } from './RouterDropdownFilter';
import { useSelector } from 'react-redux';
import LanguageFilterAlert from '../../components/LanguageFilterAlert/LanguageFilterAlert';
import { FILTER_TYPES } from '../../constants/TopFilterConstants';
const taggedFilters = [FILTER_TYPES.AWARD_TYPE, FILTER_TYPES.LEVEL, FILTER_TYPES.DURATION, FILTER_TYPES.CONTENT_TYPE, FILTER_TYPES.LANGUAGE];

const MobileFilterSection = () => {
  const isRequesting = useSelector(state => state.filters.get('isRequesting'));
  return !isRequesting && /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs(StyledTagsContainer, {
      children: [taggedFilters.map(filter => /*#__PURE__*/_jsx(RouterFilterTags, {
        filterType: filter
      }, filter)), /*#__PURE__*/_jsx(ClearFiltersLink, {
        filtersToClear: taggedFilters
      })]
    }), /*#__PURE__*/_jsx(LanguageFilterAlert, {})]
  });
};

export default MobileFilterSection;